"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupSubscription = exports.Group = exports.EThirdPartyEmailServices = exports.EContactGroupType = void 0;
const Common_1 = require("./Common");
const Base_1 = require("./Base");
const index_1 = require("../index");
var EContactGroupType;
(function (EContactGroupType) {
    EContactGroupType["AUTO"] = "auto";
    EContactGroupType["MANUAL"] = "manual";
})(EContactGroupType || (exports.EContactGroupType = EContactGroupType = {}));
var EThirdPartyEmailServices;
(function (EThirdPartyEmailServices) {
    EThirdPartyEmailServices["NONE"] = "";
    EThirdPartyEmailServices["DRIP"] = "drip";
})(EThirdPartyEmailServices || (exports.EThirdPartyEmailServices = EThirdPartyEmailServices = {}));
class Group extends Base_1.Base {
    name = '';
    default = false;
    type = EContactGroupType.MANUAL;
    medium = index_1.EMedium.EMAIL;
    subscribed = null;
    unsubscribed = null;
    ignore_opt_in = false;
    third_party_id = '';
    third_party_tags = '';
    third_party_service = EThirdPartyEmailServices.NONE; // e.g. drip
    logic_fn = '';
    agents = [];
    constructor(data, olMap) {
        super('groups', 13);
        (0, Common_1.setObjectProperties)(this, data, olMap, Group);
    }
    toString() {
        return `Group: ${this.name}`;
    }
    toMinJSON(ignoreDocRef) {
        let r = super.toMinJSON(ignoreDocRef);
        ['name'].forEach(p => {
            r[p] = this[p] || null;
        });
        return r;
    }
}
exports.Group = Group;
class GroupSubscription extends Base_1.Base {
    contact = null;
    preferences = null;
    _m = ['contact'];
    _s = ['active', 'contact', 'last_date'];
    constructor(data, olMap, type, idLen) {
        super(type || 'subscriptions', idLen || 9);
        (0, Common_1.setObjectProperties)(this, data, olMap, GroupSubscription);
    }
    toString() {
        return `Subscription: ${this.contact?.name}`;
    }
    save(parent) {
        if (!this.contact?._docRef) {
            throw `Cannot save subscription without a contact.`;
        }
        if (!this.id) {
            this.id = this.contact.id;
        }
        return super.save(parent);
    }
    async toSearchJSON(opts) {
        this.last_date = Date.now();
        return super.toSearchJSON(opts);
    }
}
exports.GroupSubscription = GroupSubscription;
index_1.olm.groups = (ref, map) => {
    return new Group(ref, map);
};
index_1.olm.subscriptions = (ref, map) => {
    return new GroupSubscription(ref, map);
};
